<app-display-information-page [title]="informationPage" [content]="content" [downloadApp]="downloadApp" ></app-display-information-page>
